export default __webpack_public_path__ + "static/media/planimg3.7e0468aa.png";